import {createSelector} from 'reselect';

const selectGlobal = (state) => state.global;

const makeIsAppLoading = () => createSelector(selectGlobal, (globalState) => globalState.isAppLoading);

const makeLoaders = () => createSelector(selectGlobal, (globalState) => globalState.loaders);

const makeSelectIsLoaderVisible = (loaderName) =>
    createSelector(makeLoaders(), (loaders) => {
        const loader = loaders?.filter(({name}) => name === loaderName);

        return loader?.length;
    });

const selectNotifications = createSelector(selectGlobal, (globalState) => globalState.notifications);

const makeSelectLayoutType = () => createSelector(selectGlobal, (globalState) => globalState.layout);

const makeSelectIsNetworkOnline = () => createSelector(selectGlobal, (globalState) => globalState.isNetworkOnline);

const makeSelectIsReconnectGuideEnabled = () =>
    createSelector(selectGlobal, (globalState) => globalState.isReconnectGuideEnabled);

const makeSelectIsStartAutoSync = () => createSelector(selectGlobal, (globalState) => globalState.isStartAutoSync);

const makeSelectIsBluetoothAvailable = () =>
    createSelector(selectGlobal, (globalState) => globalState.isBluetoothAvailable);

const makeSelectIsScpCheckInProgress = () =>
    createSelector(selectGlobal, (globalState) => globalState.isScpCheckInProgress);

const selectLanguageCode = createSelector(selectGlobal, (globalState) => globalState.languageCode);

const selectIsFwuPage = createSelector(selectGlobal, (globalState) => globalState.isFwuPage);

const makeSelectErrorPageType = () => createSelector(selectGlobal, (globalState) => globalState.errorPageType);

export {
    makeIsAppLoading,
    makeLoaders,
    makeSelectErrorPageType,
    makeSelectIsBluetoothAvailable,
    makeSelectIsLoaderVisible,
    makeSelectIsNetworkOnline,
    makeSelectIsReconnectGuideEnabled,
    makeSelectIsScpCheckInProgress,
    makeSelectIsStartAutoSync,
    makeSelectLayoutType,
    selectIsFwuPage,
    selectLanguageCode,
    selectNotifications,
};
